import React from 'react'

function Project(props) {
  return (
    <div id="project-container">
    <div id="project-picture"><img id="project-image"src={require(`../image/${props.image}`)} alt="tasklist" /></div>
    <div id="project-text">
      <h1 id="project-text-title"> {props.title} </h1>
      <p id="project-text-description">{props.description}</p>
      <div id="project-text-techs">{props.tech}</div>
      <div id="project-text-buttons">
      <a href={props.live} target="_blank" rel="noreferrer"> <button className="project-buttons">live</button> </a> 
      <a href={props.github} target="_blank" rel="noreferrer"> <button className="project-buttons">code</button> </a> 
        {/* <button className="project-buttons">code</button> */}
      </div>
    </div>
</div>
  )
}

export default Project